import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
    revenueValue: number = 48575;
    partners = [
        { name: 'Amazon', logo: 'assets/images/client/amazon.svg' },
        { name: 'Google', logo: 'assets/images/client/google.svg' },
        { name: 'Lenovo', logo: 'assets/images/client/lenovo.svg' },
        { name: 'PayPal', logo: 'assets/images/client/paypal.svg' },
        { name: 'Shopify', logo: 'assets/images/client/shopify.svg' },
        { name: 'Spotify', logo: 'assets/images/client/spotify.svg' }
    ];

    services = [
        { icon: 'pi pi-file', title: 'Reconhecimento de firma', description: 'Envie documentos, valide assinaturas e acompanhe o andamento.' },
        { icon: 'pi pi-verified', title: 'Autenticação', description: 'Garanta a autenticidade de copias com segurança digital.' },
        { icon: 'pi pi-briefcase', title: 'Procuração Pública', description: 'Solicite procurações com orientação e checklist completo.' },
        { icon: 'pi pi-home', title: 'Escrituras', description: 'Agende, envie documentos e acompanhe a lavratura.' },
        { icon: 'pi pi-id-card', title: 'Abertura de Firma', description: 'Cadastre assinaturas com validação simples e rápida.' },
        { icon: 'pi pi-building', title: 'Condomínio e Registros', description: 'Documentos de condomínio com acompanhamento digital.' }
    ];


    benefits = [
        { icon: 'pi pi-check', title: 'Checklist inteligente', description: 'Saiba exatamente o que precisa enviar para cada serviço, sem adivinhação.' },
        { icon: 'pi pi-clock', title: 'Menos retrabalho', description: 'A CartórIA, nossa inteligência artificial, ajuda a preenher os formulários de forma automática e identifica problemas antes de enviar ao cartório.' },
        { icon: 'pi pi-map-marker', title: 'Cartório mais perto', description: 'Escolha cartórios parceiros próximos e mantenha todo o processo rastreável.' },
        { icon: 'pi pi-mobile', title: 'Acompanhamento em tempo real', description: 'Status, prazos, histórico, atualizações e chat com o responsável — tudo na palma da mão.' },
        { icon: 'pi pi-key', title: 'Segurança e confiança', description: 'Serviço executado pelo cartório parceiro. Não tem diferenciação entre o processo online e presencial.' },
        { icon: 'pi pi-ban', title: 'Sem assinatura ou cartão de crédito', description: 'Não é necessário assinatura ou cartão de crédito. Você só paga pelos serviços do cartório.' }

    ];

    steps = [
        { title: 'Diga o que você precisa', description: 'Escolha o serviço e informe sua cidade.' },
        { title: 'Escolha o cartório parceiro', description: 'Veja opções disponíveis perto de você.' },
        { title: 'Envie os documentos online', description: 'A CartórIA confere tudo antes de enviar ao cartório.' },
        { title: 'Acompanhe em tempo real', description: 'Status, prazos, histórico e chat com o responsável.' },
        { title: 'Só vá ao cartório quando for necessário', description: 'Para assinatura ou retirada — ou receba em casa, se o cartório disponibilizar motoboy.' }
    ];

    plans = [
        {
            name: 'Pessoa Física - Documentos Pessoais',
            price: 'Gratuito',
            description: 'Para quem precisa de serviços cartoriais pessoais de forma rapida sem sair de casa.',
            features: [
                'Solicitacao de servicos online',
                'Acompanhamento do status',
                'Atendimento por chat'
            ],
            cta: 'Criar conta gratuita',
            featured: false,
            badge: 'Mais escolhido'
        },
        {
            name: 'Despachante - Documentos de Terceiros',
            price: 'R$ 12,00',
            description: 'Para quem precisa resolver documentos de terceiros de forma rápida com visilibidade e gestão de pedidos.',
            features: [
                'Solicitacao de servicos online',
                'Acompanhamento do status',
                'Atendimento por chat',
                'Gestão de pedidos por cliente',
                'Relatórios e notificações'
            ],
            cta: 'Assinar agora',
            featured: false,
            badge: null
        },
        {
            name: 'Cartório - Parceiros',
            price: 'R$ 15,00',
            description: 'Cartórios parceiros para gerenciar o fluxo de serviços de forma completa.',
            features: [
                'Gestão de pedidos por cliente / colaborador',
                'Organização por prioridade',
                'Controle de financeiro e dashboard',
                'Fluxo configuravel',
                'Equipe e permissoes',
                'Atendimento por chat',
                'Relatórios e notificações',
                'Produtividade e tempo de atendimento'
            ],
            cta: 'Falar com o time',
            featured: false,
            badge: null
        }
    ];

    constructor(private router: Router) {}

    ngOnInit(): void {
        // Animate revenue counter
        this.animateCounter();
    }

    navigateToLogin(): void {
        this.router.navigate(['/login']);
    }

    navigateToSignup(): void {
        this.router.navigate(['/login/signup']);
    }

    scrollTo(sectionId: string): void {
        const target = document.getElementById(sectionId);
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    private animateCounter(): void {
        const target = 48575;
        const duration = 2000;
        const steps = 60;
        const increment = target / steps;
        let current = 0;

        const timer = setInterval(() => {
            current += increment;
            if (current >= target) {
                this.revenueValue = target;
                clearInterval(timer);
            } else {
                this.revenueValue = Math.floor(current);
            }
        }, duration / steps);
    }
}
